import { LegacyCard, IndexTable, Text, Link, LegacyStack, Pagination, Divider, ExceptionList } from '@shopify/polaris';
import { getDeliveries } from '../../../services/deliveriesService';
import { useEffect, useState, useContext } from 'react';
import { SET_ERROR } from '../../../context/ToastReducer';
import ToastContext from '../../../context/ToastContext';
import { useHistory } from 'react-router';
import fillZeros from '../../../helpers/fillZeros';
import { HorizontalDotsMinor } from '@shopify/polaris-icons';
import moment from 'moment';

const ListDeliveries = ({ page, depositId }) => {
  const [, dispatchToast] = useContext(ToastContext);
  const [response, setResponse] = useState(null);

  const history = useHistory();
  const showUserEndpoint = (id) => `/deliveries/${id}?r=${window.btoa('/deliveries/page/' + response.metadata.page)}`;

  const callDB = (page = 1, limit = 10) =>
    getDeliveries({ page, limit, depositId })
      .then((res) => {
        setResponse(res.data);
        history.push(`/deliveries/page/${page}${window.location.search}`);
      })
      .catch((e) => {
        dispatchToast({ type: SET_ERROR, payload: e.response.data });
      });

  useEffect(() => {
    callDB(page);
    // eslint-disable-next-line
  }, []);

  const headingMarkup = [
    { title: '' },
    { title: 'Nombre' },
    { title: 'Fecha de facturación' },
    { title: 'Enviado' },
    { title: 'Aceptado' },
    { title: 'Productos' },
  ];

  const rowMarkup = (
    { id, deposit, status, invoiceDate, name, stockQtyExpected, stockQty, distinctProducts },
    index,
  ) => (
    <IndexTable.Row id={id} key={id} position={index}>
      <IndexTable.Cell>
        <Link dataPrimaryLink url={showUserEndpoint(id)}></Link>#{fillZeros(id, 4)}
      </IndexTable.Cell>
      <IndexTable.Cell>
        <Text variant="bodyMd" fontWeight="bold" as="span">
          {name}
        </Text>
        {status === 'OPEN' && (
          <ExceptionList
            items={[
              {
                icon: HorizontalDotsMinor,
                status: !deposit ? 'critical' : 'warning',
                title: `${!deposit ? 'Sin depósito asignado. ' : 'Pendiente de transferencia'}`,
              },
            ]}
          />
        )}
      </IndexTable.Cell>

      {invoiceDate ? <IndexTable.Cell>{moment(invoiceDate).format('DD/MM/YYYY')}</IndexTable.Cell> : <></>}
      <IndexTable.Cell>{stockQtyExpected}</IndexTable.Cell>
      <IndexTable.Cell>{stockQty}</IndexTable.Cell>
      <IndexTable.Cell>{distinctProducts}</IndexTable.Cell>
    </IndexTable.Row>
  );

  return <>
    {response && (
      <>
        <IndexTable
          resourceName={{
            singular: 'entrega',
            plural: 'entregas',
          }}
          itemCount={response.data.length ?? 0}
          headings={headingMarkup}
          selectable={false}
        >
          {response.data.map((r, k) => rowMarkup(r, k))}
        </IndexTable>
        <Divider borderStyle="divider" />
        <LegacyCard.Section>
          <LegacyStack distribution="center">
            <Pagination
              hasPrevious={response.metadata.prev}
              onPrevious={() => callDB(response.metadata.page - 1, response.metadata.limit)}
              hasNext={response.metadata.next}
              onNext={() => callDB(response.metadata.page + 1, response.metadata.limit)}
            />
          </LegacyStack>
        </LegacyCard.Section>
      </>
    )}
  </>;
};
export default ListDeliveries;
